module.exports = __webpack_public_path__ + "img/int3.0338f057.jpg";